import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './faq/HeroSection';
import { EDMSection } from './faq/EDMSection';
import { HighSpeedMachiningSection } from './faq/HighSpeedMachiningSection';
import { LaserCuttingSection } from './faq/LaserCuttingSection';
export function FAQPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2250">
      <SeoBar data-id="element-2251" />
      <Header data-id="element-2252" />
      <main className="flex-grow" data-id="element-2253">
        <div className="w-full bg-gray-50 pb-20" data-id="element-2254">
          <HeroSection data-id="element-2255" />
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 space-y-10" data-id="element-2256">
            <EDMSection data-id="element-2257" />
            <hr className="border-gray-300" data-id="element-2258" />
            <HighSpeedMachiningSection data-id="element-2259" />
            <hr className="border-gray-300" data-id="element-2260" />
            <LaserCuttingSection data-id="element-2261" />
          </div>
        </div>
      </main>
      <Footer data-id="element-2262" />
    </div>;
}